<template>
   <header>
      <div class="container">
         <div class="row">
            <div class="col-md-4 col-sm-10 col-xs-10">
               <h2 class="sticky-logo ms-hide"><router-link to="/">ARTUROS PIZZA & PASTA</router-link></h2>
            </div>
            <nav class="col-md-8 col-sm-2 col-xs-2">
               <a class="cmn-toggle-switch cmn-toggle-switch__htx open_close" @click.prevent="openMobileMenu($event)" href="javascript:void(0)"><span>Menu mobile</span></a>
               <div class="main-menu">
                  <div id="header_menu">
                     <h2 style="font-family: 'Righteous', cursive; color: #FFF">
                        ARTUROS PIZZA & PASTA</h2>
                  </div>
                  <a href="#" class="open_close" id="close_in" @click.prevent="closeMobileMenu($event)"><i class="icon_close"></i></a>
                  <ul v-if="!isLoggedIn">
                     <li><a href="tel:0245720884" style="font-size:16px"><span class="fa fa-phone"></span> 0245720884</a></li> 
                     <li><a href="javascript:void(0)" data-toggle="modal" data-target="#register" @click.prevent="openPopup('register')"><i class="fa fa-user" style="margin-right: 10px;"></i>Register</a></li>
                     <li><a href="javascript:void(0)" data-toggle="modal" data-target="#register" @click.prevent="openPopup('login')"><i class="fa fa-sign-in" style="margin-right: 10px;"></i>Login</a></li>
                  </ul>
                  <ul v-else>
                     <li style="color:#fff;">Welcome {{authName}}</li>
                     <li><router-link to="/profile"> <i class="fa fa-user" style="margin-right: 10px;"></i>Profile </router-link></li>
                  <!-- <li><a href="javascript:void(0)" @click="getProfile()"><i class="fa fa-user" style="margin-right: 10px;"></i>My Profile</a></li> -->
                  <li><a href="javascript:void(0)" id="btn-logout" @click.prevent="AccountLogout()"><i class="fa fa-power-off" style="margin-right: 10px;"></i>Logout</a></li>
                  </ul>
               </div>
            </nav>

         </div>

      </div>
   </header>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'MainHeader',
  created() {
   this.$store.watch( getters => getters.isLoggedIn),
   this.$store.watch( getters => getters.authToken),
   this.$store.watch( getters => getters.authName)
  },
  computed: {
        ...mapGetters({
            isLoggedIn: 'isLoggedIn',
            authToken: 'authToken',
            authName: 'authName',
        })
    },
  methods: {
     openMobileMenu(event){
        $(event.target.parentNode).addClass('active');
        $(".main-menu").addClass('show');
     },
     closeMobileMenu(event){
        $(event.target.parentNode.parentNode).removeClass('show');
        $(".cmn-toggle-switch__htx").removeClass('active');
     },
     openPopup(type){
        this.$store.dispatch('openPopup', type)
     },
     AccountLogout(){
         this.$store.dispatch('accountLogout').then(res => {
            this.$fire({
               title: "",
               text: "Successfully Logout",
               type: "success",
               timer: 3000
            }).then(r => {
               window.location.href = '/' 
            });
         })
     }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
